import GetExpenseDataLocal from "./GetExpenseDataInLocal";
import * as actionType from "../../../context/actions";

const EditExpenseDataInLocal = async (state, dispatch, id, expenseData) => {

    try {

        // Retrieve existing invoices from localStorage
        const existingData = JSON.parse(localStorage.getItem("LOCAL_EXPENSE")) || [];
        const expenseIndex = existingData.findIndex(expense => expense.uniqueID == id);




        const data = {
            companyId: expenseData?.companyId?.toString() || "",
            createdDate: new Date().getTime().toString(),
            amount: expenseData?.amount?.toString() || "",
            expenseCategory: expenseData?.category.toString() || "",
            expenseDate: expenseData?.expenseDate || new Date().toISOString().slice(0, 10), // Defaults to today
            expenseDescription: expenseData?.description.toString() || "",
            expenseId: expenseData?.expenseId?.toString() || "",
            paymentMethod: expenseData?.paymentMethod || "Cash",
            expenseName: expenseData?.expenseName || "",
            updateDate: expenseData?.updateDate?.toString() || new Date().getTime().toString(),
            currency: expenseData?.currency?.toString() || ""
        }

        if (expenseIndex !== -1) {

            existingData[expenseIndex] = data;
        } else {
            // If invoice doesn't exist, add it
            // existingData.push(data);
        }

        // Save updated invoices back to localStorage
        localStorage.setItem("LOCAL_EXPENSE", JSON.stringify(existingData));

        setTimeout(() => {
            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
        }, 5000);

        // Fetch updated invoice data
        await GetExpenseDataLocal(state, dispatch);

        return { success: true, message: "Expense updated successfully!" };
    } catch (error) {
        return { success: false, message: error };
    }
};

export default EditExpenseDataInLocal;
